module.exports = ".filter-value-form {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  .filter-value-form mat-input-container {\n    width: calc(100% - 150px); }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/filters/filter-value-form/filter-value-form.component.scss
// module id = ./libs/atenea-cms-brand/src/filters/filter-value-form/filter-value-form.component.scss
// module chunks = main